function promotionsInit() {
  const cards = document.querySelectorAll('.promotions__card, .offer__card--promotion');
  if (cards.length === 0) return;

  const featuredBlock = document.getElementById('featured_promotions');
  const registeredBlock = document.getElementById('registered_promotions');
  const nonceInput = document.getElementById('promotion_nonce');
  const nonce = nonceInput?.value;
  const ajaxUrl = '/wp-admin/admin-ajax.php';

  cards.forEach((item) => {
    item.addEventListener('click', async (e) => {
      const button = e.target.closest('.js-promotion-register');
      if (!button || button.disabled) return;

      e.preventDefault();

      const card = button.closest('.promotions__card, .offer__card--promotion');
      const promotionId = card?.dataset.id;
      const registeredTextStr = button.dataset.registeredText || 'Registered';

      if (!promotionId || button.classList.contains('promotions__card--is-loading')) return;

      button.classList.add('promotions__card--is-loading');
      button.disabled = true;

      const params = new URLSearchParams();
      params.append('action', 'register_promotion');
      params.append('promotion_id', promotionId);
      params.append('nonce', nonce);

      const response = await fetch(ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
      });

      if (!response.ok) {
        button.classList.remove('promotions__card--is-loading');
        button.disabled = false;
        console.error('Failed to register promotion');
        return;
      }

      const result = await response.json();

      if (!result.success) {
        console.log(result.data?.message || 'Failed to register.');
        return;
      }

      const registeredText = document.createElement('div');
      registeredText.className = 'promotions__card-registered';
      registeredText.textContent = registeredTextStr;

      button.classList.remove('promotions__card--is-loading');
      button.disabled = false;

      button.replaceWith(registeredText);

      // Move card to Registered block
      if (registeredBlock) {
        const registeredCards = registeredBlock.querySelector('.promotions__cards');
        if (registeredCards) {
          registeredCards.appendChild(card);
          registeredBlock.classList.remove('hidden');
        }
      }

      // Check if featured block is now empty
      if (featuredBlock) {
        const featuredCards = featuredBlock.querySelector('.promotions__cards');
        if (featuredCards && featuredCards.children.length === 0) {
          featuredBlock.classList.add('hidden');
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', promotionsInit);
